// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Maps every media asset to its AVIF/WebP variants using real imports.

import opt_ai_search_avif1280 from "@/assets/media/opt/ai-search-1280.avif.asset.json";
import opt_ai_search_avif640 from "@/assets/media/opt/ai-search-640.avif.asset.json";
import opt_ai_search_webp1280 from "@/assets/media/opt/ai-search-1280.webp.asset.json";
import opt_ai_search_webp640 from "@/assets/media/opt/ai-search-640.webp.asset.json";
import opt_austin_avif1280 from "@/assets/media/opt/austin-1280.avif.asset.json";
import opt_austin_avif640 from "@/assets/media/opt/austin-640.avif.asset.json";
import opt_austin_webp1280 from "@/assets/media/opt/austin-1280.webp.asset.json";
import opt_austin_webp640 from "@/assets/media/opt/austin-640.webp.asset.json";
import opt_blog_default_avif1280 from "@/assets/media/opt/blog-default-1280.avif.asset.json";
import opt_blog_default_avif640 from "@/assets/media/opt/blog-default-640.avif.asset.json";
import opt_blog_default_webp1280 from "@/assets/media/opt/blog-default-1280.webp.asset.json";
import opt_blog_default_webp640 from "@/assets/media/opt/blog-default-640.webp.asset.json";
import opt_deliverables_avif1280 from "@/assets/media/opt/deliverables-1280.avif.asset.json";
import opt_deliverables_avif640 from "@/assets/media/opt/deliverables-640.avif.asset.json";
import opt_deliverables_webp1280 from "@/assets/media/opt/deliverables-1280.webp.asset.json";
import opt_deliverables_webp640 from "@/assets/media/opt/deliverables-640.webp.asset.json";
import opt_hero_abstract_avif1280 from "@/assets/media/opt/hero-abstract-1280.avif.asset.json";
import opt_hero_abstract_avif640 from "@/assets/media/opt/hero-abstract-640.avif.asset.json";
import opt_hero_abstract_webp1280 from "@/assets/media/opt/hero-abstract-1280.webp.asset.json";
import opt_hero_abstract_webp640 from "@/assets/media/opt/hero-abstract-640.webp.asset.json";
import opt_ind_automotive_avif1280 from "@/assets/media/opt/ind-automotive-1200.avif.asset.json";
import opt_ind_automotive_avif640 from "@/assets/media/opt/ind-automotive-640.avif.asset.json";
import opt_ind_automotive_webp1280 from "@/assets/media/opt/ind-automotive-1200.webp.asset.json";
import opt_ind_automotive_webp640 from "@/assets/media/opt/ind-automotive-640.webp.asset.json";
import opt_ind_ecommerce_avif1280 from "@/assets/media/opt/ind-ecommerce-1200.avif.asset.json";
import opt_ind_ecommerce_avif640 from "@/assets/media/opt/ind-ecommerce-640.avif.asset.json";
import opt_ind_ecommerce_webp1280 from "@/assets/media/opt/ind-ecommerce-1200.webp.asset.json";
import opt_ind_ecommerce_webp640 from "@/assets/media/opt/ind-ecommerce-640.webp.asset.json";
import opt_ind_healthcare_avif1280 from "@/assets/media/opt/ind-healthcare-1200.avif.asset.json";
import opt_ind_healthcare_avif640 from "@/assets/media/opt/ind-healthcare-640.avif.asset.json";
import opt_ind_healthcare_webp1280 from "@/assets/media/opt/ind-healthcare-1200.webp.asset.json";
import opt_ind_healthcare_webp640 from "@/assets/media/opt/ind-healthcare-640.webp.asset.json";
import opt_ind_hvac_home_services_avif1280 from "@/assets/media/opt/ind-hvac-home-services-1200.avif.asset.json";
import opt_ind_hvac_home_services_avif640 from "@/assets/media/opt/ind-hvac-home-services-640.avif.asset.json";
import opt_ind_hvac_home_services_webp1280 from "@/assets/media/opt/ind-hvac-home-services-1200.webp.asset.json";
import opt_ind_hvac_home_services_webp640 from "@/assets/media/opt/ind-hvac-home-services-640.webp.asset.json";
import opt_ind_legal_avif1280 from "@/assets/media/opt/ind-legal-1200.avif.asset.json";
import opt_ind_legal_avif640 from "@/assets/media/opt/ind-legal-640.avif.asset.json";
import opt_ind_legal_webp1280 from "@/assets/media/opt/ind-legal-1200.webp.asset.json";
import opt_ind_legal_webp640 from "@/assets/media/opt/ind-legal-640.webp.asset.json";
import opt_ind_professional_services_avif1280 from "@/assets/media/opt/ind-professional-services-1200.avif.asset.json";
import opt_ind_professional_services_avif640 from "@/assets/media/opt/ind-professional-services-640.avif.asset.json";
import opt_ind_professional_services_webp1280 from "@/assets/media/opt/ind-professional-services-1200.webp.asset.json";
import opt_ind_professional_services_webp640 from "@/assets/media/opt/ind-professional-services-640.webp.asset.json";
import opt_ind_real_estate_avif1280 from "@/assets/media/opt/ind-real-estate-1200.avif.asset.json";
import opt_ind_real_estate_avif640 from "@/assets/media/opt/ind-real-estate-640.avif.asset.json";
import opt_ind_real_estate_webp1280 from "@/assets/media/opt/ind-real-estate-1200.webp.asset.json";
import opt_ind_real_estate_webp640 from "@/assets/media/opt/ind-real-estate-640.webp.asset.json";
import opt_ind_saas_avif1280 from "@/assets/media/opt/ind-saas-1200.avif.asset.json";
import opt_ind_saas_avif640 from "@/assets/media/opt/ind-saas-640.avif.asset.json";
import opt_ind_saas_webp1280 from "@/assets/media/opt/ind-saas-1200.webp.asset.json";
import opt_ind_saas_webp640 from "@/assets/media/opt/ind-saas-640.webp.asset.json";
import opt_ind_security_automation_avif1280 from "@/assets/media/opt/ind-security-automation-1200.avif.asset.json";
import opt_ind_security_automation_avif640 from "@/assets/media/opt/ind-security-automation-640.avif.asset.json";
import opt_ind_security_automation_webp1280 from "@/assets/media/opt/ind-security-automation-1200.webp.asset.json";
import opt_ind_security_automation_webp640 from "@/assets/media/opt/ind-security-automation-640.webp.asset.json";
import opt_loc_cedar_park_avif1280 from "@/assets/media/opt/loc-cedar-park-1280.avif.asset.json";
import opt_loc_cedar_park_avif640 from "@/assets/media/opt/loc-cedar-park-640.avif.asset.json";
import opt_loc_cedar_park_webp1280 from "@/assets/media/opt/loc-cedar-park-1280.webp.asset.json";
import opt_loc_cedar_park_webp640 from "@/assets/media/opt/loc-cedar-park-640.webp.asset.json";
import opt_loc_dallas_avif1280 from "@/assets/media/opt/loc-dallas-1280.avif.asset.json";
import opt_loc_dallas_avif640 from "@/assets/media/opt/loc-dallas-640.avif.asset.json";
import opt_loc_dallas_webp1280 from "@/assets/media/opt/loc-dallas-1280.webp.asset.json";
import opt_loc_dallas_webp640 from "@/assets/media/opt/loc-dallas-640.webp.asset.json";
import opt_loc_fort_worth_avif1280 from "@/assets/media/opt/loc-fort-worth-1280.avif.asset.json";
import opt_loc_fort_worth_avif640 from "@/assets/media/opt/loc-fort-worth-640.avif.asset.json";
import opt_loc_fort_worth_webp1280 from "@/assets/media/opt/loc-fort-worth-1280.webp.asset.json";
import opt_loc_fort_worth_webp640 from "@/assets/media/opt/loc-fort-worth-640.webp.asset.json";
import opt_loc_frisco_avif1280 from "@/assets/media/opt/loc-frisco-1280.avif.asset.json";
import opt_loc_frisco_avif640 from "@/assets/media/opt/loc-frisco-640.avif.asset.json";
import opt_loc_frisco_webp1280 from "@/assets/media/opt/loc-frisco-1280.webp.asset.json";
import opt_loc_frisco_webp640 from "@/assets/media/opt/loc-frisco-640.webp.asset.json";
import opt_loc_georgetown_avif1280 from "@/assets/media/opt/loc-georgetown-1280.avif.asset.json";
import opt_loc_georgetown_avif640 from "@/assets/media/opt/loc-georgetown-640.avif.asset.json";
import opt_loc_georgetown_webp1280 from "@/assets/media/opt/loc-georgetown-1280.webp.asset.json";
import opt_loc_georgetown_webp640 from "@/assets/media/opt/loc-georgetown-640.webp.asset.json";
import opt_loc_houston_avif1280 from "@/assets/media/opt/loc-houston-1280.avif.asset.json";
import opt_loc_houston_avif640 from "@/assets/media/opt/loc-houston-640.avif.asset.json";
import opt_loc_houston_webp1280 from "@/assets/media/opt/loc-houston-1280.webp.asset.json";
import opt_loc_houston_webp640 from "@/assets/media/opt/loc-houston-640.webp.asset.json";
import opt_loc_plano_avif1280 from "@/assets/media/opt/loc-plano-1280.avif.asset.json";
import opt_loc_plano_avif640 from "@/assets/media/opt/loc-plano-640.avif.asset.json";
import opt_loc_plano_webp1280 from "@/assets/media/opt/loc-plano-1280.webp.asset.json";
import opt_loc_plano_webp640 from "@/assets/media/opt/loc-plano-640.webp.asset.json";
import opt_loc_round_rock_avif1280 from "@/assets/media/opt/loc-round-rock-1280.avif.asset.json";
import opt_loc_round_rock_avif640 from "@/assets/media/opt/loc-round-rock-640.avif.asset.json";
import opt_loc_round_rock_webp1280 from "@/assets/media/opt/loc-round-rock-1280.webp.asset.json";
import opt_loc_round_rock_webp640 from "@/assets/media/opt/loc-round-rock-640.webp.asset.json";
import opt_loc_san_antonio_avif1280 from "@/assets/media/opt/loc-san-antonio-1280.avif.asset.json";
import opt_loc_san_antonio_avif640 from "@/assets/media/opt/loc-san-antonio-640.avif.asset.json";
import opt_loc_san_antonio_webp1280 from "@/assets/media/opt/loc-san-antonio-1280.webp.asset.json";
import opt_loc_san_antonio_webp640 from "@/assets/media/opt/loc-san-antonio-640.webp.asset.json";
import opt_loc_the_woodlands_avif1280 from "@/assets/media/opt/loc-the-woodlands-1280.avif.asset.json";
import opt_loc_the_woodlands_avif640 from "@/assets/media/opt/loc-the-woodlands-640.avif.asset.json";
import opt_loc_the_woodlands_webp1280 from "@/assets/media/opt/loc-the-woodlands-1280.webp.asset.json";
import opt_loc_the_woodlands_webp640 from "@/assets/media/opt/loc-the-woodlands-640.webp.asset.json";
import opt_process_avif1280 from "@/assets/media/opt/process-1280.avif.asset.json";
import opt_process_avif640 from "@/assets/media/opt/process-640.avif.asset.json";
import opt_process_webp1280 from "@/assets/media/opt/process-1280.webp.asset.json";
import opt_process_webp640 from "@/assets/media/opt/process-640.webp.asset.json";
import opt_svc_aeo_geo_avif1280 from "@/assets/media/opt/svc-aeo-geo-1200.avif.asset.json";
import opt_svc_aeo_geo_avif640 from "@/assets/media/opt/svc-aeo-geo-640.avif.asset.json";
import opt_svc_aeo_geo_webp1280 from "@/assets/media/opt/svc-aeo-geo-1200.webp.asset.json";
import opt_svc_aeo_geo_webp640 from "@/assets/media/opt/svc-aeo-geo-640.webp.asset.json";
import opt_svc_analytics_reporting_avif1280 from "@/assets/media/opt/svc-analytics-reporting-1200.avif.asset.json";
import opt_svc_analytics_reporting_avif640 from "@/assets/media/opt/svc-analytics-reporting-640.avif.asset.json";
import opt_svc_analytics_reporting_webp1280 from "@/assets/media/opt/svc-analytics-reporting-1200.webp.asset.json";
import opt_svc_analytics_reporting_webp640 from "@/assets/media/opt/svc-analytics-reporting-640.webp.asset.json";
import opt_svc_content_strategy_avif1280 from "@/assets/media/opt/svc-content-strategy-1200.avif.asset.json";
import opt_svc_content_strategy_avif640 from "@/assets/media/opt/svc-content-strategy-640.avif.asset.json";
import opt_svc_content_strategy_webp1280 from "@/assets/media/opt/svc-content-strategy-1200.webp.asset.json";
import opt_svc_content_strategy_webp640 from "@/assets/media/opt/svc-content-strategy-640.webp.asset.json";
import opt_svc_cro_avif1280 from "@/assets/media/opt/svc-cro-1200.avif.asset.json";
import opt_svc_cro_avif640 from "@/assets/media/opt/svc-cro-640.avif.asset.json";
import opt_svc_cro_webp1280 from "@/assets/media/opt/svc-cro-1200.webp.asset.json";
import opt_svc_cro_webp640 from "@/assets/media/opt/svc-cro-640.webp.asset.json";
import opt_svc_ecommerce_seo_avif1280 from "@/assets/media/opt/svc-ecommerce-seo-1200.avif.asset.json";
import opt_svc_ecommerce_seo_avif640 from "@/assets/media/opt/svc-ecommerce-seo-640.avif.asset.json";
import opt_svc_ecommerce_seo_webp1280 from "@/assets/media/opt/svc-ecommerce-seo-1200.webp.asset.json";
import opt_svc_ecommerce_seo_webp640 from "@/assets/media/opt/svc-ecommerce-seo-640.webp.asset.json";
import opt_svc_google_business_profile_avif1280 from "@/assets/media/opt/svc-google-business-profile-1200.avif.asset.json";
import opt_svc_google_business_profile_avif640 from "@/assets/media/opt/svc-google-business-profile-640.avif.asset.json";
import opt_svc_google_business_profile_webp1280 from "@/assets/media/opt/svc-google-business-profile-1200.webp.asset.json";
import opt_svc_google_business_profile_webp640 from "@/assets/media/opt/svc-google-business-profile-640.webp.asset.json";
import opt_svc_link_building_avif1280 from "@/assets/media/opt/svc-link-building-1200.avif.asset.json";
import opt_svc_link_building_avif640 from "@/assets/media/opt/svc-link-building-640.avif.asset.json";
import opt_svc_link_building_webp1280 from "@/assets/media/opt/svc-link-building-1200.webp.asset.json";
import opt_svc_link_building_webp640 from "@/assets/media/opt/svc-link-building-640.webp.asset.json";
import opt_svc_local_seo_avif1280 from "@/assets/media/opt/svc-local-seo-1200.avif.asset.json";
import opt_svc_local_seo_avif640 from "@/assets/media/opt/svc-local-seo-640.avif.asset.json";
import opt_svc_local_seo_webp1280 from "@/assets/media/opt/svc-local-seo-1200.webp.asset.json";
import opt_svc_local_seo_webp640 from "@/assets/media/opt/svc-local-seo-640.webp.asset.json";
import opt_svc_ppc_avif1280 from "@/assets/media/opt/svc-ppc-1200.avif.asset.json";
import opt_svc_ppc_avif640 from "@/assets/media/opt/svc-ppc-640.avif.asset.json";
import opt_svc_ppc_webp1280 from "@/assets/media/opt/svc-ppc-1200.webp.asset.json";
import opt_svc_ppc_webp640 from "@/assets/media/opt/svc-ppc-640.webp.asset.json";
import opt_svc_saas_seo_avif1280 from "@/assets/media/opt/svc-saas-seo-1200.avif.asset.json";
import opt_svc_saas_seo_avif640 from "@/assets/media/opt/svc-saas-seo-640.avif.asset.json";
import opt_svc_saas_seo_webp1280 from "@/assets/media/opt/svc-saas-seo-1200.webp.asset.json";
import opt_svc_saas_seo_webp640 from "@/assets/media/opt/svc-saas-seo-640.webp.asset.json";
import opt_svc_technical_seo_avif1280 from "@/assets/media/opt/svc-technical-seo-1200.avif.asset.json";
import opt_svc_technical_seo_avif640 from "@/assets/media/opt/svc-technical-seo-640.avif.asset.json";
import opt_svc_technical_seo_webp1280 from "@/assets/media/opt/svc-technical-seo-1200.webp.asset.json";
import opt_svc_technical_seo_webp640 from "@/assets/media/opt/svc-technical-seo-640.webp.asset.json";
import opt_svc_web_design_avif1280 from "@/assets/media/opt/svc-web-design-1200.avif.asset.json";
import opt_svc_web_design_avif640 from "@/assets/media/opt/svc-web-design-640.avif.asset.json";
import opt_svc_web_design_webp1280 from "@/assets/media/opt/svc-web-design-1200.webp.asset.json";
import opt_svc_web_design_webp640 from "@/assets/media/opt/svc-web-design-640.webp.asset.json";
import opt_team_avif1280 from "@/assets/media/opt/team-1280.avif.asset.json";
import opt_team_avif640 from "@/assets/media/opt/team-640.avif.asset.json";
import opt_team_webp1280 from "@/assets/media/opt/team-1280.webp.asset.json";
import opt_team_webp640 from "@/assets/media/opt/team-640.webp.asset.json";
import opt_texas_avif1280 from "@/assets/media/opt/texas-1280.avif.asset.json";
import opt_texas_avif640 from "@/assets/media/opt/texas-640.avif.asset.json";
import opt_texas_webp1280 from "@/assets/media/opt/texas-1280.webp.asset.json";
import opt_texas_webp640 from "@/assets/media/opt/texas-640.webp.asset.json";
import opt_workspace_avif1280 from "@/assets/media/opt/workspace-1280.avif.asset.json";
import opt_workspace_avif640 from "@/assets/media/opt/workspace-640.avif.asset.json";
import opt_workspace_webp1280 from "@/assets/media/opt/workspace-1280.webp.asset.json";
import opt_workspace_webp640 from "@/assets/media/opt/workspace-640.webp.asset.json";

export type MediaVariant = {
  avif640: string;
  webp640: string;
  avif1280: string;
  webp1280: string;
};

export const MEDIA_VARIANTS: Record<string, MediaVariant> = {
  "ai-search": {
    avif640: opt_ai_search_avif640.url,
    webp640: opt_ai_search_webp640.url,
    avif1280: opt_ai_search_avif1280.url,
    webp1280: opt_ai_search_webp1280.url,
  },
  "austin": {
    avif640: opt_austin_avif640.url,
    webp640: opt_austin_webp640.url,
    avif1280: opt_austin_avif1280.url,
    webp1280: opt_austin_webp1280.url,
  },
  "blog-default": {
    avif640: opt_blog_default_avif640.url,
    webp640: opt_blog_default_webp640.url,
    avif1280: opt_blog_default_avif1280.url,
    webp1280: opt_blog_default_webp1280.url,
  },
  "deliverables": {
    avif640: opt_deliverables_avif640.url,
    webp640: opt_deliverables_webp640.url,
    avif1280: opt_deliverables_avif1280.url,
    webp1280: opt_deliverables_webp1280.url,
  },
  "hero-abstract": {
    avif640: opt_hero_abstract_avif640.url,
    webp640: opt_hero_abstract_webp640.url,
    avif1280: opt_hero_abstract_avif1280.url,
    webp1280: opt_hero_abstract_webp1280.url,
  },
  "ind-automotive": {
    avif640: opt_ind_automotive_avif640.url,
    webp640: opt_ind_automotive_webp640.url,
    avif1280: opt_ind_automotive_avif1280.url,
    webp1280: opt_ind_automotive_webp1280.url,
  },
  "ind-ecommerce": {
    avif640: opt_ind_ecommerce_avif640.url,
    webp640: opt_ind_ecommerce_webp640.url,
    avif1280: opt_ind_ecommerce_avif1280.url,
    webp1280: opt_ind_ecommerce_webp1280.url,
  },
  "ind-healthcare": {
    avif640: opt_ind_healthcare_avif640.url,
    webp640: opt_ind_healthcare_webp640.url,
    avif1280: opt_ind_healthcare_avif1280.url,
    webp1280: opt_ind_healthcare_webp1280.url,
  },
  "ind-hvac-home-services": {
    avif640: opt_ind_hvac_home_services_avif640.url,
    webp640: opt_ind_hvac_home_services_webp640.url,
    avif1280: opt_ind_hvac_home_services_avif1280.url,
    webp1280: opt_ind_hvac_home_services_webp1280.url,
  },
  "ind-legal": {
    avif640: opt_ind_legal_avif640.url,
    webp640: opt_ind_legal_webp640.url,
    avif1280: opt_ind_legal_avif1280.url,
    webp1280: opt_ind_legal_webp1280.url,
  },
  "ind-professional-services": {
    avif640: opt_ind_professional_services_avif640.url,
    webp640: opt_ind_professional_services_webp640.url,
    avif1280: opt_ind_professional_services_avif1280.url,
    webp1280: opt_ind_professional_services_webp1280.url,
  },
  "ind-real-estate": {
    avif640: opt_ind_real_estate_avif640.url,
    webp640: opt_ind_real_estate_webp640.url,
    avif1280: opt_ind_real_estate_avif1280.url,
    webp1280: opt_ind_real_estate_webp1280.url,
  },
  "ind-saas": {
    avif640: opt_ind_saas_avif640.url,
    webp640: opt_ind_saas_webp640.url,
    avif1280: opt_ind_saas_avif1280.url,
    webp1280: opt_ind_saas_webp1280.url,
  },
  "ind-security-automation": {
    avif640: opt_ind_security_automation_avif640.url,
    webp640: opt_ind_security_automation_webp640.url,
    avif1280: opt_ind_security_automation_avif1280.url,
    webp1280: opt_ind_security_automation_webp1280.url,
  },
  "loc-cedar-park": {
    avif640: opt_loc_cedar_park_avif640.url,
    webp640: opt_loc_cedar_park_webp640.url,
    avif1280: opt_loc_cedar_park_avif1280.url,
    webp1280: opt_loc_cedar_park_webp1280.url,
  },
  "loc-dallas": {
    avif640: opt_loc_dallas_avif640.url,
    webp640: opt_loc_dallas_webp640.url,
    avif1280: opt_loc_dallas_avif1280.url,
    webp1280: opt_loc_dallas_webp1280.url,
  },
  "loc-fort-worth": {
    avif640: opt_loc_fort_worth_avif640.url,
    webp640: opt_loc_fort_worth_webp640.url,
    avif1280: opt_loc_fort_worth_avif1280.url,
    webp1280: opt_loc_fort_worth_webp1280.url,
  },
  "loc-frisco": {
    avif640: opt_loc_frisco_avif640.url,
    webp640: opt_loc_frisco_webp640.url,
    avif1280: opt_loc_frisco_avif1280.url,
    webp1280: opt_loc_frisco_webp1280.url,
  },
  "loc-georgetown": {
    avif640: opt_loc_georgetown_avif640.url,
    webp640: opt_loc_georgetown_webp640.url,
    avif1280: opt_loc_georgetown_avif1280.url,
    webp1280: opt_loc_georgetown_webp1280.url,
  },
  "loc-houston": {
    avif640: opt_loc_houston_avif640.url,
    webp640: opt_loc_houston_webp640.url,
    avif1280: opt_loc_houston_avif1280.url,
    webp1280: opt_loc_houston_webp1280.url,
  },
  "loc-plano": {
    avif640: opt_loc_plano_avif640.url,
    webp640: opt_loc_plano_webp640.url,
    avif1280: opt_loc_plano_avif1280.url,
    webp1280: opt_loc_plano_webp1280.url,
  },
  "loc-round-rock": {
    avif640: opt_loc_round_rock_avif640.url,
    webp640: opt_loc_round_rock_webp640.url,
    avif1280: opt_loc_round_rock_avif1280.url,
    webp1280: opt_loc_round_rock_webp1280.url,
  },
  "loc-san-antonio": {
    avif640: opt_loc_san_antonio_avif640.url,
    webp640: opt_loc_san_antonio_webp640.url,
    avif1280: opt_loc_san_antonio_avif1280.url,
    webp1280: opt_loc_san_antonio_webp1280.url,
  },
  "loc-the-woodlands": {
    avif640: opt_loc_the_woodlands_avif640.url,
    webp640: opt_loc_the_woodlands_webp640.url,
    avif1280: opt_loc_the_woodlands_avif1280.url,
    webp1280: opt_loc_the_woodlands_webp1280.url,
  },
  "process": {
    avif640: opt_process_avif640.url,
    webp640: opt_process_webp640.url,
    avif1280: opt_process_avif1280.url,
    webp1280: opt_process_webp1280.url,
  },
  "svc-aeo-geo": {
    avif640: opt_svc_aeo_geo_avif640.url,
    webp640: opt_svc_aeo_geo_webp640.url,
    avif1280: opt_svc_aeo_geo_avif1280.url,
    webp1280: opt_svc_aeo_geo_webp1280.url,
  },
  "svc-analytics-reporting": {
    avif640: opt_svc_analytics_reporting_avif640.url,
    webp640: opt_svc_analytics_reporting_webp640.url,
    avif1280: opt_svc_analytics_reporting_avif1280.url,
    webp1280: opt_svc_analytics_reporting_webp1280.url,
  },
  "svc-content-strategy": {
    avif640: opt_svc_content_strategy_avif640.url,
    webp640: opt_svc_content_strategy_webp640.url,
    avif1280: opt_svc_content_strategy_avif1280.url,
    webp1280: opt_svc_content_strategy_webp1280.url,
  },
  "svc-cro": {
    avif640: opt_svc_cro_avif640.url,
    webp640: opt_svc_cro_webp640.url,
    avif1280: opt_svc_cro_avif1280.url,
    webp1280: opt_svc_cro_webp1280.url,
  },
  "svc-ecommerce-seo": {
    avif640: opt_svc_ecommerce_seo_avif640.url,
    webp640: opt_svc_ecommerce_seo_webp640.url,
    avif1280: opt_svc_ecommerce_seo_avif1280.url,
    webp1280: opt_svc_ecommerce_seo_webp1280.url,
  },
  "svc-google-business-profile": {
    avif640: opt_svc_google_business_profile_avif640.url,
    webp640: opt_svc_google_business_profile_webp640.url,
    avif1280: opt_svc_google_business_profile_avif1280.url,
    webp1280: opt_svc_google_business_profile_webp1280.url,
  },
  "svc-link-building": {
    avif640: opt_svc_link_building_avif640.url,
    webp640: opt_svc_link_building_webp640.url,
    avif1280: opt_svc_link_building_avif1280.url,
    webp1280: opt_svc_link_building_webp1280.url,
  },
  "svc-local-seo": {
    avif640: opt_svc_local_seo_avif640.url,
    webp640: opt_svc_local_seo_webp640.url,
    avif1280: opt_svc_local_seo_avif1280.url,
    webp1280: opt_svc_local_seo_webp1280.url,
  },
  "svc-ppc": {
    avif640: opt_svc_ppc_avif640.url,
    webp640: opt_svc_ppc_webp640.url,
    avif1280: opt_svc_ppc_avif1280.url,
    webp1280: opt_svc_ppc_webp1280.url,
  },
  "svc-saas-seo": {
    avif640: opt_svc_saas_seo_avif640.url,
    webp640: opt_svc_saas_seo_webp640.url,
    avif1280: opt_svc_saas_seo_avif1280.url,
    webp1280: opt_svc_saas_seo_webp1280.url,
  },
  "svc-technical-seo": {
    avif640: opt_svc_technical_seo_avif640.url,
    webp640: opt_svc_technical_seo_webp640.url,
    avif1280: opt_svc_technical_seo_avif1280.url,
    webp1280: opt_svc_technical_seo_webp1280.url,
  },
  "svc-web-design": {
    avif640: opt_svc_web_design_avif640.url,
    webp640: opt_svc_web_design_webp640.url,
    avif1280: opt_svc_web_design_avif1280.url,
    webp1280: opt_svc_web_design_webp1280.url,
  },
  "team": {
    avif640: opt_team_avif640.url,
    webp640: opt_team_webp640.url,
    avif1280: opt_team_avif1280.url,
    webp1280: opt_team_webp1280.url,
  },
  "texas": {
    avif640: opt_texas_avif640.url,
    webp640: opt_texas_webp640.url,
    avif1280: opt_texas_avif1280.url,
    webp1280: opt_texas_webp1280.url,
  },
  "workspace": {
    avif640: opt_workspace_avif640.url,
    webp640: opt_workspace_webp640.url,
    avif1280: opt_workspace_avif1280.url,
    webp1280: opt_workspace_webp1280.url,
  },
};
